<template>
  <el-dialog
    :model-value="isOpen"
    @close="$emit('close')"
  >
    <h1 class="tw-leading-[38px] tw-tracking-wider tw-mb-8">
      {{ $t('main.recovery.title_first') }}
    </h1>
    <el-form
      ref="Form"
      :model="form"
      :rules="formRules"
      label-position="top"
      :disabled="isLoading"
      autocomplete="off"
      hide-required-asterisk
      @submit.native.prevent="submitForm"
    >
      <i-form-item
        :label="$t('common.fields.login')"
        prop="username"
        class="tw-mb-10"
      >
        <el-input
          v-model="form.username"
          autofocus
          autocomplete="off"
        />
      </i-form-item>
      <div class="tw-flex tw-flex-col tw-items-end">
        <div class="tw-w-[548px] tw-h-px tw-mr-[-40px] tw-bg-gray tw-mb-6" />
        <div>
          <i-button
            type="primary"
            size="large"
            native-type="submit"
            class="tw-mb-[-16px]"
          >
            {{ $t('common.actions.reset') }}
          </i-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import _get from 'lodash/get';
import AuthService from '@/services/AuthService';

export default {
  name: 'ResetPasswordDialog',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        username: '',
      },
      formRules: {
        username: [
          { required: true, message: this.$t('common.fields.required') },
        ],
      },
      isLoading: false,
    };
  },
  methods: {
    async submitForm() {
      let token = undefined;
      if (this.recaptchaRequired){
        await this.$recaptchaLoaded();
        token = await this.$recaptcha('login');
      }

      this.isLoading = true;
      AuthService.resetUserPassword(this.form.username)
        .then(() => {
          this.isLoading = false;
          this.$emit('close');
          this.$message.success({
            message: this.$capitalize(this.$t('main.recovery.reset_success_message')),
            showClose: true,
            offset: this.$getMessageOffsetFromTop(),
          });
        })
        .catch((error) => {
          this.isLoading = false;

          const message = _get(error, 'response.data.message');
          this.$message.error({
            message: this.$capitalize(message || this.$t('core.error.internal_server_error')),
            showClose: true,
            offset: this.$getMessageOffsetFromTop(),
          });

          if (error && error.data && error.data.recaptcha_requested) {
            this.recaptchaRequired = true;
          }
        });
    },
  },
};
</script>
